// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/activity_occurrence.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schedules_v1_resources_activity } from "./activity_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/activity_occurrence.proto.
 */
export const file_studyo_today_schedules_v1_resources_activity_occurrence = /*@__PURE__*/
  fileDesc("Cj1zdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9hY3Rpdml0eV9vY2N1cnJlbmNlLnByb3RvEiNzdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcyK9AQoSQWN0aXZpdHlPY2N1cnJlbmNlEj8KCGFjdGl2aXR5GAEgASgLMi0uc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMuQWN0aXZpdHkSGAoQYWJzb2x1dGVfb3JkaW5hbBgCIAEoBRIPCgdvcmRpbmFsGAMgASgFEhQKDHRlcm1fb3JkaW5hbBgEIAEoBRIRCglyb29tX25hbWUYBSABKAkSEgoKaXNfc2tpcHBlZBgGIAEoCEIrqgIoU3R1ZHlvLlRvZGF5LlNjaGVkdWxlcy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_schedules_v1_resources_activity]);

/**
 * Describes the message studyo.today.schedules.v1.resources.ActivityOccurrence.
 * Use `create(ActivityOccurrenceSchema)` to create a new message.
 */
export const ActivityOccurrenceSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_activity_occurrence, 0);

